import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { runIfFn } from "./chunk-EBS47JIL.mjs";

// src/components/button.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { mode, transparentize } from "@chakra-ui/theme-tools";
var baseStyle = defineStyle({
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
});
var variantGhost = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  if (c === "gray") {
    return {
      color: mode("inherit", "whiteAlpha.900")(props),
      _hover: {
        bg: mode("gray.100", "whiteAlpha.200")(props)
      },
      _active: {
        bg: mode("gray.200", "whiteAlpha.300")(props)
      }
    };
  }
  var darkHoverBg = transparentize("".concat(c, ".200"), 0.12)(theme);
  var darkActiveBg = transparentize("".concat(c, ".200"), 0.24)(theme);
  return {
    color: mode("".concat(c, ".600"), "".concat(c, ".200"))(props),
    bg: "transparent",
    _hover: {
      bg: mode("".concat(c, ".50"), darkHoverBg)(props)
    },
    _active: {
      bg: mode("".concat(c, ".100"), darkActiveBg)(props)
    }
  };
});
var variantOutline = defineStyle(function (props) {
  var c = props.colorScheme;
  var borderColor = mode("gray.200", "whiteAlpha.300")(props);
  return _objectSpread({
    border: "1px solid",
    borderColor: c === "gray" ? borderColor : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
      marginBottom: "-1px"
    }
  }, runIfFn(variantGhost, props));
});
var accessibleColorMap = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
};
var variantSolid = defineStyle(function (props) {
  var _a;
  var c = props.colorScheme;
  if (c === "gray") {
    var bg2 = mode("gray.100", "whiteAlpha.200")(props);
    return {
      bg: bg2,
      _hover: {
        bg: mode("gray.200", "whiteAlpha.300")(props),
        _disabled: {
          bg: bg2
        }
      },
      _active: {
        bg: mode("gray.300", "whiteAlpha.400")(props)
      }
    };
  }
  var _ref = (_a = accessibleColorMap[c]) != null ? _a : {},
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? "".concat(c, ".500") : _ref$bg,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "white" : _ref$color,
    _ref$hoverBg = _ref.hoverBg,
    hoverBg = _ref$hoverBg === void 0 ? "".concat(c, ".600") : _ref$hoverBg,
    _ref$activeBg = _ref.activeBg,
    activeBg = _ref$activeBg === void 0 ? "".concat(c, ".700") : _ref$activeBg;
  var background = mode(bg, "".concat(c, ".200"))(props);
  return {
    bg: background,
    color: mode(color, "gray.800")(props),
    _hover: {
      bg: mode(hoverBg, "".concat(c, ".300"))(props),
      _disabled: {
        bg: background
      }
    },
    _active: {
      bg: mode(activeBg, "".concat(c, ".400"))(props)
    }
  };
});
var variantLink = defineStyle(function (props) {
  var c = props.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: mode("".concat(c, ".700"), "".concat(c, ".500"))(props)
    }
  };
});
var variantUnstyled = defineStyle({
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
});
var variants = {
  ghost: variantGhost,
  outline: variantOutline,
  solid: variantSolid,
  link: variantLink,
  unstyled: variantUnstyled
};
var sizes = {
  lg: defineStyle({
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  }),
  md: defineStyle({
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  }),
  sm: defineStyle({
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  }),
  xs: defineStyle({
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  })
};
var buttonTheme = defineStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
});
export { buttonTheme };